import Button from "@mui/material/Button";
import useDownloader from "react-use-downloader";
import { boxes, ContentProps, elements } from "./type";

const DownloadButton: React.FC<{ fileUrl: string; filename: string }> = (
  props
) => {
  const { size, elapsed, percentage, download, cancel, error, isInProgress } =
    useDownloader();

  return (
    <Button
      key={"contact"}
      variant="contained"
      sx={{
        borderRadius: "24px",
        background: "linear-gradient(135deg, #b5d43c 0%, #00946f 100%)",
        fontWeight: 700,
        width: "200px",
        margin: "auto",
        height: "48px",
        border: 0,
      }}
      onClick={() => download(props.fileUrl, props.filename)}
    >
      {"ダウンロード"}
    </Button>
  );
};
DownloadButton.displayName = "DownloadButton";

export const contents: ContentProps[] = [
  {
    contents: [
      elements([
        {
          fontSize: "42px",
          lineHeight: 4.2,
          color: "#424242",
          description: "資料ダウンロード",
        },
      ]),
      boxes([
        {
          title: "リーフレット",
          titleOption: {
            // border: "1px #333 solid",
            fontSize: "24px",
            color: "#424242",
            backgroundColor: "",
          },
          image: { src: "/Leaflet202205.png", width: 305, height: 430 },
          option: { border: "", backgroundColor: "transparent" },
          descriptions: ["LearningBookの機能を紹介したリーフレットです"],
          element: (
            <DownloadButton
              fileUrl={"/Leaflet202205.pdf"}
              filename={"LEarningbook_Leaflet202205.pdf"}
            />
          ),
          xs: 6,
          md: 6,
        },
        {
          title: "IT Media掲載記事",
          titleOption: {
            // border: "1px #333 solid",
            fontSize: "24px",
            color: "#424242",
            backgroundColor: "",
          },
          image: {
            src: "/ITMedia202205.png",
            width: 305,
            height: 430,
          },
          option: { border: "", backgroundColor: "transparent" },
          descriptions: [
            "2022年5月、ITMediaに掲載されたLearningBookについての記事です",
          ],
          element: (
            <DownloadButton
              fileUrl={"ITMedia202205.pdf"}
              filename={"LearningBook_ITMedia掲載記事.pdf"}
            />
          ),
          xs: 6,
          md: 6,
        },
      ]),
    ],
  },
];
